import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Alert } from 'react-bootstrap';
import { camelCase } from 'lodash/fp';
import { reduxForm, Form, SubmissionError } from 'redux-form';

import { POST } from 'utils/httpMethods';
import { GridLayout } from 'components/form/layout';
import { TextField } from 'components/form/field';
import validate from 'common/formValidation/lib';
import { buildmanagementActValidation } from 'common/formValidation/settings/managementActSettingsValidation';

const CreateNewMangementAct = ({ error, handleSubmit, hideForm, hiddenAll, showForm }) => {
    const [hidden, setHidden] = useState(true);

    const showNewForm = useCallback((e) => {
        e.preventDefault();
        setHidden(false);
        showForm();
    }, [setHidden]);
    const hideNewForm = useCallback((e) => {
        e.preventDefault();
        setHidden(true);
        hideForm();
    }, [setHidden]);

    return (
        <div className={classNames('new-simu', { hidden: hiddenAll })}>
            {hidden ? (
                <button onClick={showNewForm}>Nouveau partenaire</button>
            ) : (
                <button onClick={hideNewForm} className="cancel">Annuler</button>
            )}
            <div className={classNames('new-simulation-form', { hidden })}>
                <h1 className="text-center">Paramètres du nouveau partenaire</h1>
                {error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <GridLayout className="double condensed full-width">
                        <TextField
                            name="name"
                            title="Nom"
                        />
                        <TextField
                            name="referrerCode"
                            title="Code apporteur"
                        />

                    </GridLayout>
                    <div className="submit">
                        <button type="submit">Créer</button>
                    </div>
                </Form>
            </div>
        </div>
    );
};

CreateNewMangementAct.propTypes = {
    handleSubmit: PropTypes.func,
    hiddenAll: PropTypes.bool,
    showForm: PropTypes.func,
    hideForm: PropTypes.func,
    error: PropTypes.string,
};

export default reduxForm({
    form: 'simulation-managementAct-create',
    onSubmit: async (values) => {
        const id = `simulation.managementAct.${camelCase(values.name)}`;

        try {
            await POST('/api/settings/managementAct', { body: { id, value: values } });
        } catch (error) {
            const data = await error.response.json();

            throw new SubmissionError({ _error: 'La Création à échoué !', ...data });
        }
    },
    onSubmitSuccess: () => {
        document.location.href = '/admin/settings/simulation';
    },
    validate: validate(buildmanagementActValidation()),
})(CreateNewMangementAct);
